<template>
  <div>
    <report-header @generate="load" @filterChanged="filterChanged"
      @onChangedDateStart="onChangedDateStart" @onChangedDateEnd="onChangedDateEnd" @onChangedGroup="onChangedGroup"
      :filterOptions="filterOptions" :isGenerateDisabled="isGenerateDisabled" @paginationChanged="paginationChanged" @onChangedTypeDocuments="onChangedTypeDocuments"/>
      <b-table striped hover small responsive id="tablereport"
        :items="documents"
        :fields="documentsFields"
        :filter="filter"
        :per-page="perPage"
        :current-page="currentPage"/>
    <table-manager-bottom
      :totalRows="totalRows" :perPage="perPage"
      v-model="currentPage"/>
  </div>
</template>

<script>
import moment from 'moment'

export default {
  props: {
    userId: 0
  },
  data () {
    return {
      getStore: {
        numDateEnd: 0,
        numDateStart: 0,
        userId: 0,
        group_id: 0,
        type: 0
      },
      documents: [],
      documentsFields: [
        {key: 'id', label: this.$i18n.t('Internal number'), sortable: true},
        {key: 'alt_id', label: this.$i18n.t('Alternative number'), sortable: true},
        {key: 'ext_num', label: this.$i18n.t('External number'), sortable: true},
        {key: 'account_id', label: this.$i18n.t('Account ID'), sortable: true},
        {key: 'full_name', label: this.$i18n.t('FullName'), sortable: true},
        {key: 'kpp', label: this.$i18n.t('Reg code'), sortable: true},
        {key: 'tax', label: this.$i18n.t('ITIN'), sortable: true},
        {key: 'year', label: this.$i18n.t('Year'), sortable: true},
        {key: 'month', label: this.$i18n.t('Month'), sortable: true},
        {key: 'time', label: this.$i18n.t('Time'), sortable: true},
        {key: 'is_payed', label: this.$i18n.t('Paid'), sortable: true},
        {key: 'total_sum_with_tax', label: this.$i18n.t('Total (incl. taxes)'), sortable: true},
        {key: 'total_tax', label: this.$i18n.t('Tax total'), sortable: true},
        {key: 'total_sum', label: this.$i18n.t('Charges without tax total'), sortable: true},
        {key: 'odt_created', label: this.$i18n.t('Creation date'), sortable: true},
        {key: 'odt_modified', label: this.$i18n.t('Modification date'), sortable: true},
        {key: 'status', label: this.$i18n.t('Status'), sortable: true},
        {key: 'mailed', label: this.$i18n.t('Is mailed'), sortable: true}
      ],
      isGenerateDisabled: false,
      selectGroup: 0,
      selectTypeDocuments: 1,
      filter: null,
      perPage: 20,
      totalRows: 0,
      currentPage: 1,
      dateStart: new Date(),
      dateEnd: new Date(),
      filterOptions: {
        isFilterGroup: true,
        isFilterTypeTraffic: false,
        isFilterTypeDocuments: true,
        isFilterTypeUsers: false,
        isFilterCollector: false
      }
    }
  },
  methods: {
    async load () {
      this.isGenerateDisabled = true
      let numDateEnd = Number(this.dateEnd) / 1000
      if (numDateEnd > 2147483647) numDateEnd = 2147483647
      let numDateStart = Number(this.dateStart) / 1000
      if (numDateStart > 2147483647) numDateStart = 2147483647
      this.getStore.numDateEnd = numDateEnd
      this.getStore.numDateStart = numDateStart
      this.getStore.type = this.selectTypeDocuments
      if (!this.userId) {
        this.getStore.group_id = this.selectGroup
      } else {
        this.getStore.userId = this.userId
      }
      await this.$store.dispatch('Reports/GET_DOCUMENTS', this.getStore).then(response => {
        this.documents = this.$store.getters['Reports/DOCUMENTS']
        for (let el of this.documents) {
          let time = JSON.parse(JSON.stringify(el.invoice_date))
          el.time = moment(Number(time) * 1000).format('YYYY-MM-DD hh:mm')
          el.year = moment(Number(time) * 1000).format('YYYY')
          el.month = moment(Number(time) * 1000).format('MM')

          if (el.is_payed === 1) {
            el.is_payed = true
          } else {
            el.is_payed = false
          }

          if (el.is_pdf_mailed === 1 || el.is_odt_mailed === 1) {
            el.mailed = true
          } else {
            el.mailed = false
          }

          if (!el.odt_created) {
            el.odt_created = this.$i18n.t('Not installed')
          } else {
            el.odt_created = moment(Number(el.odt_created) * 1000).format('MM-DD-YYYY')
          }

          if (!el.odt_modified) {
            el.odt_modified = this.$i18n.t('Not installed')
          } else {
            el.odt_modified = moment(Number(el.odt_modified) * 1000).format('MM-DD-YYYY')
          }

          switch (el.odt_status) {
            case -1:
              el.status = this.$i18n.t('Not created')
              break
            case 0:
              el.status = this.$i18n.t('Created')
              break
            case 1:
              el.status = this.$i18n.t('Modified')
              break
            case 2:
              el.status = this.$i18n.t('Deleted')
              break
            default:
              el.status = this.$i18n.t('Unknown')
              break
          }
        }
        this.loadDone()
        this.totalRows = this.documents.length
        this.$emit('input', this.totalRows)
      })
    },
    onChangedDateStart (value) {
      this.dateStart = value
    },
    onChangedDateEnd (value) {
      this.dateEnd = value
    },
    onChangedGroup (value) {
      this.selectGroup = (value)
    },
    onChangedTypeDocuments (value) {
      this.selectTypeDocuments = (value)
    },
    filterChanged (value) {
      this.filter = value
    },
    loadDone () {
      this.isGenerateDisabled = false
    },
    paginationChanged (value) {
      this.perPage = value
    }
  },
  mounted () {
    this.loadDone()
  }
}
</script>



// WEBPACK FOOTER //
// src/pages/reports/payments/documents/main.vue